import TextareaAutosize from 'react-textarea-autosize';
import { Button } from '../../../Utility/Button';
import EditableList from '../../../Utility/EditableList';
import TabSection from './TabSection';
import TabHeadline from './TabHeadline';
import InfoButton from '../../../Utility/InfoButton';

interface DescriptionTabProps {
    prompt: any;
    i18n: any;
    handlePromptUpdate: any;
    PromptActions: any;
}

function DescriptionTab({ prompt, i18n, handlePromptUpdate, PromptActions }: DescriptionTabProps) {
    return (
        <div className="w-full">
            <TabHeadline
                title={i18n.translate({
                    id: 'tabs.description.title',
                    sourceName: 'Prompt',
                })}
            />
            <InfoButton configKey="description" />

            <TabSection
                title={i18n.translate({ id: 'tabs.description.section.description.title', sourceName: 'Prompt' })}
                subline={i18n.translate({
                    id: 'tabs.description.section.description.subtitle',
                    sourceName: 'Prompt',
                })}
            >
                <TextareaAutosize
                    className="bg-input-backgroundColor w-full p-3 border border-input-borderColor rounded-lg outline-none focus:border-primary transition-all duration-100"
                    value={prompt.description ?? ''}
                    onChange={(e) => handlePromptUpdate({ description: e.target.value })}
                    minRows={2}
                    maxRows={5}
                />
            </TabSection>
            <TabSection
                title={i18n.translate({ id: 'tabs.description.section.examples.title', sourceName: 'Prompt' })}
                subline={i18n.translate({ id: 'tabs.description.section.examples.subtitle', sourceName: 'Prompt' })}
            >
                {prompt.examples.map((example: any, index: number) => (
                    <EditableList
                        key={index}
                        itemValue={example}
                        placeholder={i18n.translate({
                            id: 'placeholderExample',
                            sourceName: 'Prompt',
                        })}
                        handleChange={PromptActions.handleExampleChange}
                        handleRemove={PromptActions.removeExample}
                        index={index}
                    />
                ))}
                <div className="w-fit">
                    {prompt.examples.length < 4 && (
                        <Button variant="secondary" onClick={PromptActions.addExample}>
                            {i18n.translate({
                                id: 'addExample',
                                sourceName: 'Prompt',
                            })}
                        </Button>
                    )}
                </div>
            </TabSection>
        </div>
    );
}

export default DescriptionTab;
